import jQuery from 'jquery';
import _ from 'lodash';
import moment from 'moment';
import toastr from 'admin-lte/plugins/toastr/toastr.min';
import Chart from 'admin-lte/plugins/chart.js/Chart';
import dragula from 'dragula';
import axios from 'axios';

import 'popper.js';
import 'bootstrap';
import 'bootstrap-select';
import 'summernote/dist/summernote-bs4';

window.$ = window.jQuery = jQuery;
window._ = _;
window.moment = moment;
window.toastr = toastr;
window.Chart = Chart;
window.dragula = dragula;

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
